<template>
  <v-app-bar :app="!isWidget" color="primary" flat>
    <v-row no-gutters justify="center">
      <v-row
        style="max-width: 1240px"
        justify="start"
        no-gutters
        align="center"
      >
        <v-img
          :style="!isWidget ? 'cursor: pointer' : ''"
          @click="goSite"
          :src="storeDetails.configs.template.logo"
          max-width="175"
          contain
          class="ma-0 pa-0"
        />
        <v-spacer></v-spacer>
        <Countdown
          v-if="orderDetails && $route.name !== 'Finished'"
          :orderDetails="orderDetails"
          :showLabel="true"
        />
        <a
          v-if="
            storeDetails &&
            storeDetails.configs.template.url_help &&
            $vuetify.breakpoint.mdAndUp
          "
          class="white--text checkout-h4"
          style="font-weight: 450; cursor: pointer; text-decoration: none"
          :href="storeDetails.configs.template.url_help"
          target="_blank"
          >{{ $t("header.help") }}</a
        >

        <MenuLanguage v-if="$vuetify.breakpoint.mdAndUp" />

        <MenuMobile v-if="!$vuetify.breakpoint.mdAndUp" />

        <div class="divider mx-4" v-if="loggedUser"></div>

        <MenuUserLogged v-if="loggedUser" :loggedUser="loggedUser" />

        <v-icon
          class="ml-4"
          v-if="isWidget"
          @click="$emit('closeWidget')"
          color="white"
          >mdi-close</v-icon
        >
      </v-row>
    </v-row>
    <default-dialog
      :title="$t('cart.cancelCartTitle')"
      :description="$t('cart.cancelCartDescription')"
      :textConfirmButton="$t('general.yes')"
      :textCloseButton="$t('general.no')"
      :show="showDialog"
      :loading="loading"
      @confirm="clearCheckout"
      @close="clearCheckout"
    />
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import Countdown from "./Countdown.vue";
import DefaultDialog from "./DefaultDialog.vue";
import MenuLanguage from "./header/MenuLanguage.vue";
import MenuMobile from "./header/MenuMobile.vue";
import MenuUserLogged from "./header/MenuUserLogged.vue";
// import Countdown from "./Countdown.vue";
export default {
  props: ["isWidget"],

  data() {
    return {
      showDialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      "eventDetails",
      "orderDetails",
      "loggedUser",
      "storeDetails",
      "eventId",
    ]),
    imgUrl() {
      if (
        this.eventDetails.midias.find(
          (midia) => midia.codigo_midia === 1 && midia.ativo === 1
        )
      )
        return this.eventDetails.midias.find(
          (midia) => midia.codigo_midia === 1 && midia.ativo === 1
        ).url;
      else return "";
    },
  },
  methods: {
    goSite() {
      if (this.isWidget) return;

      if (this.$route.name !== "Cart" && this.$route.name !== "Finished")
        this.showDialog = true;
      else
        window.open(
          `${this.storeDetails.siteUrl}/evento/${this.eventDetails.codigo}`,
          "_self"
        );
    },
    clearCheckout() {
      this.loading = true;
      this.$store.dispatch("resetCheckout", this.eventId);
      window.open(this.storeDetails.siteUrl, "_self");
    },
  },
  components: {
    MenuUserLogged,
    Countdown,
    DefaultDialog,
    MenuLanguage,
    MenuMobile,
  },
};
</script>

<style scoped>
.header-checkout {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}
.divider {
  height: 25px;
  width: 1px;
  background-color: white;
}
</style>
